import { makeStyles } from '@/styles/theme/tss-react';

import { darkOrLightStyle } from '@/utils/styles';

interface Props {
  isOnDark: boolean | undefined;
}

export const useStyles = makeStyles<Props>({
  name: 'Radio',
})(({ brandColors, typography: { pxToRem } }, props) => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: pxToRem(8),
    cursor: 'pointer',
    '&:has(input:disabled)': {
      opacity: 0.3,
      pointerEvents: 'none',
      cursor: 'default',
    },
  },
  disabled: {
    opacity: 0.3,
    pointerEvents: 'none',
    cursor: 'default',
  },
  input: {
    position: 'absolute',
    width: 1,
    height: 1,
    margin: -1,
    padding: 0,
    overflow: 'hidden',
    clip: 'rect(0 0 0 0)',
    whiteSpace: 'nowrap',
    border: 0,
    outline: 'none',
    '&:checked ~ * [data-radio-icon="checked"]': {
      display: 'flex',
    },
    '&:checked ~ * [data-radio-icon="unchecked"]': {
      display: 'none',
    },
    '&:focus-visible ~ [data-radio-icon-wrapper]': {
      outline: `${pxToRem(1.5)} solid ${brandColors.tintsChargeBlue50}`,
      borderRadius: pxToRem(4),
    },
  },
  icon: {
    color: darkOrLightStyle(props)(brandColors.white, brandColors.black),
    display: 'flex',
    flexShrink: 0,
  },
  checkedIcon: {
    display: 'none',
  },
  uncheckedIcon: {
    display: 'flex',
  },
}));
